/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BlockInputBody,
  EmailsOutputBody,
  ErrorModel,
  NewSiteUserInputBody,
  OAuthProvidersOutputBody,
  SetOAuthProviderInputBody,
  SiteEmailsParams,
  SiteUserBody,
  SiteUsersListParams,
  SiteUsersOutputBody,
  TypeBody
} from '../model';

import { facetaFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type siteUsersBlockResponse200 = {
  data: SiteUserBody
  status: 200
}

export type siteUsersBlockResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteUsersBlockResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteUsersBlockResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteUsersBlockResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteUsersBlockResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteUsersBlockResponseSuccess = (siteUsersBlockResponse200) & {
  headers: Headers;
};
export type siteUsersBlockResponseError = (siteUsersBlockResponse401 | siteUsersBlockResponse403 | siteUsersBlockResponse404 | siteUsersBlockResponse422 | siteUsersBlockResponse500) & {
  headers: Headers;
};

export type siteUsersBlockResponse = (siteUsersBlockResponseSuccess | siteUsersBlockResponseError)

export const getSiteUsersBlockUrl = (userId: string,) => {




  return `/site-users/${userId}/block`
}

/**
 * Заблокированный не входит; его сессии закрываются сразу.
 * @summary Заблокировать или вернуть
 */
export const siteUsersBlock = async (userId: string,
    blockInputBody: NonReadonly<BlockInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<siteUsersBlockResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<siteUsersBlockResponse>(getSiteUsersBlockUrl(userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(blockInputBody)
  }
);}





export const getSiteUsersBlockQueryKey = (userId: string,
    blockInputBody?: NonReadonly<BlockInputBody>,) => {
    return [
    'POST', `/site-users/${userId}/block`, blockInputBody
    ] as const;
    }


export const getSiteUsersBlockQueryOptions = <TData = Awaited<ReturnType<typeof siteUsersBlock>>, TError = ErrorModel>(userId: string,
    blockInputBody: NonReadonly<BlockInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersBlock>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteUsersBlockQueryKey(userId,blockInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteUsersBlock>>> = ({ signal }) => siteUsersBlock(userId,blockInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteUsersBlock>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteUsersBlockQueryResult = NonNullable<Awaited<ReturnType<typeof siteUsersBlock>>>
export type SiteUsersBlockQueryError = ErrorModel


export function useSiteUsersBlock<TData = Awaited<ReturnType<typeof siteUsersBlock>>, TError = ErrorModel>(
 userId: string,
    blockInputBody: NonReadonly<BlockInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersBlock>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersBlock>>,
          TError,
          Awaited<ReturnType<typeof siteUsersBlock>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersBlock<TData = Awaited<ReturnType<typeof siteUsersBlock>>, TError = ErrorModel>(
 userId: string,
    blockInputBody: NonReadonly<BlockInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersBlock>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersBlock>>,
          TError,
          Awaited<ReturnType<typeof siteUsersBlock>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersBlock<TData = Awaited<ReturnType<typeof siteUsersBlock>>, TError = ErrorModel>(
 userId: string,
    blockInputBody: NonReadonly<BlockInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersBlock>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Заблокировать или вернуть
 */

export function useSiteUsersBlock<TData = Awaited<ReturnType<typeof siteUsersBlock>>, TError = ErrorModel>(
 userId: string,
    blockInputBody: NonReadonly<BlockInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersBlock>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteUsersBlockQueryOptions(userId,blockInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type siteUsersLogoutResponse200 = {
  data: SiteUserBody
  status: 200
}

export type siteUsersLogoutResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteUsersLogoutResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteUsersLogoutResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteUsersLogoutResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteUsersLogoutResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteUsersLogoutResponseSuccess = (siteUsersLogoutResponse200) & {
  headers: Headers;
};
export type siteUsersLogoutResponseError = (siteUsersLogoutResponse401 | siteUsersLogoutResponse403 | siteUsersLogoutResponse404 | siteUsersLogoutResponse422 | siteUsersLogoutResponse500) & {
  headers: Headers;
};

export type siteUsersLogoutResponse = (siteUsersLogoutResponseSuccess | siteUsersLogoutResponseError)

export const getSiteUsersLogoutUrl = (userId: string,) => {




  return `/site-users/${userId}/logout`
}

/**
 * @summary Выйти на всех устройствах
 */
export const siteUsersLogout = async (userId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<siteUsersLogoutResponse> => {

  return facetaFetch<siteUsersLogoutResponse>(getSiteUsersLogoutUrl(userId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSiteUsersLogoutQueryKey = (userId: string,) => {
    return [
    'POST', `/site-users/${userId}/logout`
    ] as const;
    }


export const getSiteUsersLogoutQueryOptions = <TData = Awaited<ReturnType<typeof siteUsersLogout>>, TError = ErrorModel>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersLogout>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteUsersLogoutQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteUsersLogout>>> = ({ signal }) => siteUsersLogout(userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteUsersLogout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteUsersLogoutQueryResult = NonNullable<Awaited<ReturnType<typeof siteUsersLogout>>>
export type SiteUsersLogoutQueryError = ErrorModel


export function useSiteUsersLogout<TData = Awaited<ReturnType<typeof siteUsersLogout>>, TError = ErrorModel>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersLogout>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersLogout>>,
          TError,
          Awaited<ReturnType<typeof siteUsersLogout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersLogout<TData = Awaited<ReturnType<typeof siteUsersLogout>>, TError = ErrorModel>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersLogout>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersLogout>>,
          TError,
          Awaited<ReturnType<typeof siteUsersLogout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersLogout<TData = Awaited<ReturnType<typeof siteUsersLogout>>, TError = ErrorModel>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersLogout>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Выйти на всех устройствах
 */

export function useSiteUsersLogout<TData = Awaited<ReturnType<typeof siteUsersLogout>>, TError = ErrorModel>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersLogout>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteUsersLogoutQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type siteUsersResetResponse200 = {
  data: SiteUserBody
  status: 200
}

export type siteUsersResetResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteUsersResetResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteUsersResetResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteUsersResetResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteUsersResetResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteUsersResetResponseSuccess = (siteUsersResetResponse200) & {
  headers: Headers;
};
export type siteUsersResetResponseError = (siteUsersResetResponse401 | siteUsersResetResponse403 | siteUsersResetResponse404 | siteUsersResetResponse422 | siteUsersResetResponse500) & {
  headers: Headers;
};

export type siteUsersResetResponse = (siteUsersResetResponseSuccess | siteUsersResetResponseError)

export const getSiteUsersResetUrl = (userId: string,) => {




  return `/site-users/${userId}/reset`
}

/**
 * @summary Отправить ссылку на новый пароль
 */
export const siteUsersReset = async (userId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<siteUsersResetResponse> => {

  return facetaFetch<siteUsersResetResponse>(getSiteUsersResetUrl(userId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSiteUsersResetQueryKey = (userId: string,) => {
    return [
    'POST', `/site-users/${userId}/reset`
    ] as const;
    }


export const getSiteUsersResetQueryOptions = <TData = Awaited<ReturnType<typeof siteUsersReset>>, TError = ErrorModel>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersReset>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteUsersResetQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteUsersReset>>> = ({ signal }) => siteUsersReset(userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteUsersReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteUsersResetQueryResult = NonNullable<Awaited<ReturnType<typeof siteUsersReset>>>
export type SiteUsersResetQueryError = ErrorModel


export function useSiteUsersReset<TData = Awaited<ReturnType<typeof siteUsersReset>>, TError = ErrorModel>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersReset>>,
          TError,
          Awaited<ReturnType<typeof siteUsersReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersReset<TData = Awaited<ReturnType<typeof siteUsersReset>>, TError = ErrorModel>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersReset>>,
          TError,
          Awaited<ReturnType<typeof siteUsersReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersReset<TData = Awaited<ReturnType<typeof siteUsersReset>>, TError = ErrorModel>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersReset>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Отправить ссылку на новый пароль
 */

export function useSiteUsersReset<TData = Awaited<ReturnType<typeof siteUsersReset>>, TError = ErrorModel>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersReset>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteUsersResetQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type siteUsersVerifyResponse200 = {
  data: SiteUserBody
  status: 200
}

export type siteUsersVerifyResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteUsersVerifyResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteUsersVerifyResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteUsersVerifyResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteUsersVerifyResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteUsersVerifyResponseSuccess = (siteUsersVerifyResponse200) & {
  headers: Headers;
};
export type siteUsersVerifyResponseError = (siteUsersVerifyResponse401 | siteUsersVerifyResponse403 | siteUsersVerifyResponse404 | siteUsersVerifyResponse422 | siteUsersVerifyResponse500) & {
  headers: Headers;
};

export type siteUsersVerifyResponse = (siteUsersVerifyResponseSuccess | siteUsersVerifyResponseError)

export const getSiteUsersVerifyUrl = (userId: string,) => {




  return `/site-users/${userId}/verify`
}

/**
 * Если письмо не дошло, а человек точно свой.
 * @summary Подтвердить почту вручную
 */
export const siteUsersVerify = async (userId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<siteUsersVerifyResponse> => {

  return facetaFetch<siteUsersVerifyResponse>(getSiteUsersVerifyUrl(userId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSiteUsersVerifyQueryKey = (userId: string,) => {
    return [
    'POST', `/site-users/${userId}/verify`
    ] as const;
    }


export const getSiteUsersVerifyQueryOptions = <TData = Awaited<ReturnType<typeof siteUsersVerify>>, TError = ErrorModel>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersVerify>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteUsersVerifyQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteUsersVerify>>> = ({ signal }) => siteUsersVerify(userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteUsersVerify>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteUsersVerifyQueryResult = NonNullable<Awaited<ReturnType<typeof siteUsersVerify>>>
export type SiteUsersVerifyQueryError = ErrorModel


export function useSiteUsersVerify<TData = Awaited<ReturnType<typeof siteUsersVerify>>, TError = ErrorModel>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersVerify>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersVerify>>,
          TError,
          Awaited<ReturnType<typeof siteUsersVerify>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersVerify<TData = Awaited<ReturnType<typeof siteUsersVerify>>, TError = ErrorModel>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersVerify>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersVerify>>,
          TError,
          Awaited<ReturnType<typeof siteUsersVerify>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersVerify<TData = Awaited<ReturnType<typeof siteUsersVerify>>, TError = ErrorModel>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersVerify>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Подтвердить почту вручную
 */

export function useSiteUsersVerify<TData = Awaited<ReturnType<typeof siteUsersVerify>>, TError = ErrorModel>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersVerify>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteUsersVerifyQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type siteEmailsResponse200 = {
  data: EmailsOutputBody
  status: 200
}

export type siteEmailsResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteEmailsResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteEmailsResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteEmailsResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteEmailsResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteEmailsResponseSuccess = (siteEmailsResponse200) & {
  headers: Headers;
};
export type siteEmailsResponseError = (siteEmailsResponse401 | siteEmailsResponse403 | siteEmailsResponse404 | siteEmailsResponse422 | siteEmailsResponse500) & {
  headers: Headers;
};

export type siteEmailsResponse = (siteEmailsResponseSuccess | siteEmailsResponseError)

export const getSiteEmailsUrl = (id: string,
    kind: 'production' | 'development',
    params?: SiteEmailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sites/${id}/environments/${kind}/emails?${stringifiedParams}` : `/sites/${id}/environments/${kind}/emails`
}

/**
 * Письма посетителям окружения: что, кому и чем кончилось. Почта не настроена — статус skipped, ссылка в тексте.
 * @summary Журнал писем
 */
export const siteEmails = async (id: string,
    kind: 'production' | 'development',
    params?: SiteEmailsParams, options?: Parameters<typeof facetaFetch>[1]): Promise<siteEmailsResponse> => {

  return facetaFetch<siteEmailsResponse>(getSiteEmailsUrl(id,kind,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSiteEmailsQueryKey = (id: string,
    kind: 'production' | 'development',
    params?: SiteEmailsParams,) => {
    return [
    `/sites/${id}/environments/${kind}/emails`, ...(params ? [params] : [])
    ] as const;
    }


export const getSiteEmailsQueryOptions = <TData = Awaited<ReturnType<typeof siteEmails>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    params?: SiteEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteEmails>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteEmailsQueryKey(id,kind,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteEmails>>> = ({ signal }) => siteEmails(id,kind,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteEmails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof siteEmails>>>
export type SiteEmailsQueryError = ErrorModel


export function useSiteEmails<TData = Awaited<ReturnType<typeof siteEmails>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params: undefined |  SiteEmailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteEmails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteEmails>>,
          TError,
          Awaited<ReturnType<typeof siteEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteEmails<TData = Awaited<ReturnType<typeof siteEmails>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: SiteEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteEmails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteEmails>>,
          TError,
          Awaited<ReturnType<typeof siteEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteEmails<TData = Awaited<ReturnType<typeof siteEmails>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: SiteEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteEmails>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Журнал писем
 */

export function useSiteEmails<TData = Awaited<ReturnType<typeof siteEmails>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: SiteEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteEmails>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteEmailsQueryOptions(id,kind,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type siteUsersListResponse200 = {
  data: SiteUsersOutputBody
  status: 200
}

export type siteUsersListResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteUsersListResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteUsersListResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteUsersListResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteUsersListResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteUsersListResponseSuccess = (siteUsersListResponse200) & {
  headers: Headers;
};
export type siteUsersListResponseError = (siteUsersListResponse401 | siteUsersListResponse403 | siteUsersListResponse404 | siteUsersListResponse422 | siteUsersListResponse500) & {
  headers: Headers;
};

export type siteUsersListResponse = (siteUsersListResponseSuccess | siteUsersListResponseError)

export const getSiteUsersListUrl = (id: string,
    kind: 'production' | 'development',
    params?: SiteUsersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sites/${id}/environments/${kind}/site-users?${stringifiedParams}` : `/sites/${id}/environments/${kind}/site-users`
}

/**
 * @summary Посетители сайта
 */
export const siteUsersList = async (id: string,
    kind: 'production' | 'development',
    params?: SiteUsersListParams, options?: Parameters<typeof facetaFetch>[1]): Promise<siteUsersListResponse> => {

  return facetaFetch<siteUsersListResponse>(getSiteUsersListUrl(id,kind,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSiteUsersListQueryKey = (id: string,
    kind: 'production' | 'development',
    params?: SiteUsersListParams,) => {
    return [
    `/sites/${id}/environments/${kind}/site-users`, ...(params ? [params] : [])
    ] as const;
    }


export const getSiteUsersListQueryOptions = <TData = Awaited<ReturnType<typeof siteUsersList>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    params?: SiteUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteUsersListQueryKey(id,kind,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteUsersList>>> = ({ signal }) => siteUsersList(id,kind,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteUsersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteUsersListQueryResult = NonNullable<Awaited<ReturnType<typeof siteUsersList>>>
export type SiteUsersListQueryError = ErrorModel


export function useSiteUsersList<TData = Awaited<ReturnType<typeof siteUsersList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params: undefined |  SiteUsersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersList>>,
          TError,
          Awaited<ReturnType<typeof siteUsersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersList<TData = Awaited<ReturnType<typeof siteUsersList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: SiteUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersList>>,
          TError,
          Awaited<ReturnType<typeof siteUsersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersList<TData = Awaited<ReturnType<typeof siteUsersList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: SiteUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Посетители сайта
 */

export function useSiteUsersList<TData = Awaited<ReturnType<typeof siteUsersList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    params?: SiteUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteUsersListQueryOptions(id,kind,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type siteUsersCreateResponse201 = {
  data: SiteUserBody
  status: 201
}

export type siteUsersCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteUsersCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteUsersCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteUsersCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type siteUsersCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteUsersCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteUsersCreateResponseSuccess = (siteUsersCreateResponse201) & {
  headers: Headers;
};
export type siteUsersCreateResponseError = (siteUsersCreateResponse401 | siteUsersCreateResponse403 | siteUsersCreateResponse404 | siteUsersCreateResponse409 | siteUsersCreateResponse422 | siteUsersCreateResponse500) & {
  headers: Headers;
};

export type siteUsersCreateResponse = (siteUsersCreateResponseSuccess | siteUsersCreateResponseError)

export const getSiteUsersCreateUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/site-users`
}

/**
 * Почта сразу считается подтверждённой. Без пароля посетителю уходит письмо — задать пароль самому.
 * @summary Завести посетителя
 */
export const siteUsersCreate = async (id: string,
    kind: 'production' | 'development',
    newSiteUserInputBody: NonReadonly<NewSiteUserInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<siteUsersCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<siteUsersCreateResponse>(getSiteUsersCreateUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(newSiteUserInputBody)
  }
);}





export const getSiteUsersCreateQueryKey = (id: string,
    kind: 'production' | 'development',
    newSiteUserInputBody?: NonReadonly<NewSiteUserInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/site-users`, newSiteUserInputBody
    ] as const;
    }


export const getSiteUsersCreateQueryOptions = <TData = Awaited<ReturnType<typeof siteUsersCreate>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    newSiteUserInputBody: NonReadonly<NewSiteUserInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteUsersCreateQueryKey(id,kind,newSiteUserInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteUsersCreate>>> = ({ signal }) => siteUsersCreate(id,kind,newSiteUserInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteUsersCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteUsersCreateQueryResult = NonNullable<Awaited<ReturnType<typeof siteUsersCreate>>>
export type SiteUsersCreateQueryError = ErrorModel


export function useSiteUsersCreate<TData = Awaited<ReturnType<typeof siteUsersCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    newSiteUserInputBody: NonReadonly<NewSiteUserInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersCreate>>,
          TError,
          Awaited<ReturnType<typeof siteUsersCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersCreate<TData = Awaited<ReturnType<typeof siteUsersCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    newSiteUserInputBody: NonReadonly<NewSiteUserInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersCreate>>,
          TError,
          Awaited<ReturnType<typeof siteUsersCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersCreate<TData = Awaited<ReturnType<typeof siteUsersCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    newSiteUserInputBody: NonReadonly<NewSiteUserInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Завести посетителя
 */

export function useSiteUsersCreate<TData = Awaited<ReturnType<typeof siteUsersCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    newSiteUserInputBody: NonReadonly<NewSiteUserInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteUsersCreateQueryOptions(id,kind,newSiteUserInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type siteUsersEnableResponse201 = {
  data: TypeBody
  status: 201
}

export type siteUsersEnableResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteUsersEnableResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteUsersEnableResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteUsersEnableResponse409 = {
  data: ErrorModel
  status: 409
}

export type siteUsersEnableResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteUsersEnableResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteUsersEnableResponseSuccess = (siteUsersEnableResponse201) & {
  headers: Headers;
};
export type siteUsersEnableResponseError = (siteUsersEnableResponse401 | siteUsersEnableResponse403 | siteUsersEnableResponse404 | siteUsersEnableResponse409 | siteUsersEnableResponse422 | siteUsersEnableResponse500) & {
  headers: Headers;
};

export type siteUsersEnableResponse = (siteUsersEnableResponseSuccess | siteUsersEnableResponseError)

export const getSiteUsersEnableUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/site-users/enable`
}

/**
 * Заводит коллекцию «Пользователи» — её поля и есть поля профиля. Уже есть — 409.
 * @summary Включить вход на сайте
 */
export const siteUsersEnable = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<siteUsersEnableResponse> => {

  return facetaFetch<siteUsersEnableResponse>(getSiteUsersEnableUrl(id,kind),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSiteUsersEnableQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/site-users/enable`
    ] as const;
    }


export const getSiteUsersEnableQueryOptions = <TData = Awaited<ReturnType<typeof siteUsersEnable>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersEnable>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteUsersEnableQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteUsersEnable>>> = ({ signal }) => siteUsersEnable(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteUsersEnable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteUsersEnableQueryResult = NonNullable<Awaited<ReturnType<typeof siteUsersEnable>>>
export type SiteUsersEnableQueryError = ErrorModel


export function useSiteUsersEnable<TData = Awaited<ReturnType<typeof siteUsersEnable>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersEnable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersEnable>>,
          TError,
          Awaited<ReturnType<typeof siteUsersEnable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersEnable<TData = Awaited<ReturnType<typeof siteUsersEnable>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersEnable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersEnable>>,
          TError,
          Awaited<ReturnType<typeof siteUsersEnable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteUsersEnable<TData = Awaited<ReturnType<typeof siteUsersEnable>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersEnable>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Включить вход на сайте
 */

export function useSiteUsersEnable<TData = Awaited<ReturnType<typeof siteUsersEnable>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteUsersEnable>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteUsersEnableQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type siteOAuthListResponse200 = {
  data: OAuthProvidersOutputBody
  status: 200
}

export type siteOAuthListResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteOAuthListResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteOAuthListResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteOAuthListResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteOAuthListResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteOAuthListResponseSuccess = (siteOAuthListResponse200) & {
  headers: Headers;
};
export type siteOAuthListResponseError = (siteOAuthListResponse401 | siteOAuthListResponse403 | siteOAuthListResponse404 | siteOAuthListResponse422 | siteOAuthListResponse500) & {
  headers: Headers;
};

export type siteOAuthListResponse = (siteOAuthListResponseSuccess | siteOAuthListResponseError)

export const getSiteOAuthListUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/site-users/oauth`
}

/**
 * Google, VK ID, Яндекс ID: включён ли, ключи и адрес возврата для приложения у провайдера. Вход на сайте не включён — 404.
 * @summary Вход через соцсети
 */
export const siteOAuthList = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<siteOAuthListResponse> => {

  return facetaFetch<siteOAuthListResponse>(getSiteOAuthListUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSiteOAuthListQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/site-users/oauth`
    ] as const;
    }


export const getSiteOAuthListQueryOptions = <TData = Awaited<ReturnType<typeof siteOAuthList>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteOAuthList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteOAuthListQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteOAuthList>>> = ({ signal }) => siteOAuthList(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteOAuthList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteOAuthListQueryResult = NonNullable<Awaited<ReturnType<typeof siteOAuthList>>>
export type SiteOAuthListQueryError = ErrorModel


export function useSiteOAuthList<TData = Awaited<ReturnType<typeof siteOAuthList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteOAuthList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteOAuthList>>,
          TError,
          Awaited<ReturnType<typeof siteOAuthList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteOAuthList<TData = Awaited<ReturnType<typeof siteOAuthList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteOAuthList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteOAuthList>>,
          TError,
          Awaited<ReturnType<typeof siteOAuthList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteOAuthList<TData = Awaited<ReturnType<typeof siteOAuthList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteOAuthList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Вход через соцсети
 */

export function useSiteOAuthList<TData = Awaited<ReturnType<typeof siteOAuthList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteOAuthList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteOAuthListQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type siteOAuthSetResponse200 = {
  data: OAuthProvidersOutputBody
  status: 200
}

export type siteOAuthSetResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteOAuthSetResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteOAuthSetResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteOAuthSetResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteOAuthSetResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteOAuthSetResponseSuccess = (siteOAuthSetResponse200) & {
  headers: Headers;
};
export type siteOAuthSetResponseError = (siteOAuthSetResponse401 | siteOAuthSetResponse403 | siteOAuthSetResponse404 | siteOAuthSetResponse422 | siteOAuthSetResponse500) & {
  headers: Headers;
};

export type siteOAuthSetResponse = (siteOAuthSetResponseSuccess | siteOAuthSetResponseError)

export const getSiteOAuthSetUrl = (id: string,
    kind: 'production' | 'development',
    provider: 'google' | 'vk' | 'yandex',) => {




  return `/sites/${id}/environments/${kind}/site-users/oauth/${provider}`
}

/**
 * Включить можно только с идентификатором и (кроме VK ID) секретом.
 * @summary Ключи провайдера входа
 */
export const siteOAuthSet = async (id: string,
    kind: 'production' | 'development',
    provider: 'google' | 'vk' | 'yandex',
    setOAuthProviderInputBody: NonReadonly<SetOAuthProviderInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<siteOAuthSetResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<siteOAuthSetResponse>(getSiteOAuthSetUrl(id,kind,provider),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setOAuthProviderInputBody)
  }
);}





export const getSiteOAuthSetQueryKey = (id: string,
    kind: 'production' | 'development',
    provider: 'google' | 'vk' | 'yandex',
    setOAuthProviderInputBody?: NonReadonly<SetOAuthProviderInputBody>,) => {
    return [
    'PUT', `/sites/${id}/environments/${kind}/site-users/oauth/${provider}`, setOAuthProviderInputBody
    ] as const;
    }


export const getSiteOAuthSetQueryOptions = <TData = Awaited<ReturnType<typeof siteOAuthSet>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    provider: 'google' | 'vk' | 'yandex',
    setOAuthProviderInputBody: NonReadonly<SetOAuthProviderInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteOAuthSet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteOAuthSetQueryKey(id,kind,provider,setOAuthProviderInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteOAuthSet>>> = ({ signal }) => siteOAuthSet(id,kind,provider,setOAuthProviderInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined && provider !== null && provider !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteOAuthSet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteOAuthSetQueryResult = NonNullable<Awaited<ReturnType<typeof siteOAuthSet>>>
export type SiteOAuthSetQueryError = ErrorModel


export function useSiteOAuthSet<TData = Awaited<ReturnType<typeof siteOAuthSet>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    provider: 'google' | 'vk' | 'yandex',
    setOAuthProviderInputBody: NonReadonly<SetOAuthProviderInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteOAuthSet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteOAuthSet>>,
          TError,
          Awaited<ReturnType<typeof siteOAuthSet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteOAuthSet<TData = Awaited<ReturnType<typeof siteOAuthSet>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    provider: 'google' | 'vk' | 'yandex',
    setOAuthProviderInputBody: NonReadonly<SetOAuthProviderInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteOAuthSet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteOAuthSet>>,
          TError,
          Awaited<ReturnType<typeof siteOAuthSet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteOAuthSet<TData = Awaited<ReturnType<typeof siteOAuthSet>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    provider: 'google' | 'vk' | 'yandex',
    setOAuthProviderInputBody: NonReadonly<SetOAuthProviderInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteOAuthSet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ключи провайдера входа
 */

export function useSiteOAuthSet<TData = Awaited<ReturnType<typeof siteOAuthSet>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    provider: 'google' | 'vk' | 'yandex',
    setOAuthProviderInputBody: NonReadonly<SetOAuthProviderInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteOAuthSet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteOAuthSetQueryOptions(id,kind,provider,setOAuthProviderInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






